<template>
  <a-modal
    width="600px"
    title="创建数据集"
    v-model:visible="visible"
    :confirm-loading="confirmLoading"
  >
    <a-form ref="form"
      :model="form"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 18 }">
      <a-form-item label="数据集名称" name="chineseInstructions" required>
        <a-input v-model:value="form.chineseInstructions" placeholder="1~24个字符，可包含大小写字母、数字、中文、下划线" autocomplete="off"/>
      </a-form-item>
      <a-form-item label="说明" name="remark">
        <a-textarea v-model:value="form.remark" :row="4" />
      </a-form-item>
      <!-- <a-form-item label="数据类型">
        {{ getDataTypeName(itemAddition.itemTypeId) }}
      </a-form-item> -->
      <a-form-item label="时间范围" v-if="basicAddition.minDate || basicAddition.maxDate">
        <div>{{ basicAddition.minDate }}&emsp;至&emsp;{{ basicAddition.maxDate }}</div>
      </a-form-item>
      <a-form-item label="数量">
        <div>{{ basicAddition.pageSizeMax }}</div>
      </a-form-item>
    </a-form>
    <template v-slot:footer>
      <a-button key="back" @click="handleCancel">取消</a-button>
      <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleOk">创建</a-button>
    </template>
  </a-modal>
</template>
<script>
import { addDataSet } from '@/api/dataSet'
import { getDataTypeName } from '@/filters'
function getQuery (obj) {
  return Object.keys(obj).filter(key => obj[key]).map(key => `${key}%3D${obj[key]}`).join('%26')
}
function addKeyPrefix (obj, prefix) {
  return Object.fromEntries(Object.entries(obj).map(arr => [prefix + arr[0], arr[1]]))
}
export default {
  props: {
    basicAddition: {
      type: Object,
      default: () => {}
    },
    itemAddition: {
      type: Object,
      default: () => {}
    },
    tagAddition: {
      type: Object,
      default: () => {}
    },
    attrAddition: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      visible: false,
      confirmLoading: false,
      form: {
        chineseInstructions: '',
        remark: ''
      }
    }
  },
  methods: {
    getDataTypeName,
    open () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.form.resetFields()
        console.log(this.basicAddition)
        console.log(this.itemAddition)
        console.log(this.tagAddition)
        console.log(this.attrAddition)
      })
    },
    handleOk () {
      const basicAddition = {
        minDate: this.basicAddition.minDate,
        maxDate: this.basicAddition.maxDate,
        pageSizeMax: this.basicAddition.pageSizeMax
      }
      if (this.form.chineseInstructions) {
        const regexp = /^[\u4e00-\u9fa5A-Za-z0-9_-]{1,24}$/
        if (regexp.test(this.form.chineseInstructions)) {
          const params = {
            'dataset.addition': getQuery({
              ...basicAddition,
              ...this.itemAddition,
              ...this.tagAddition,
              ...this.attrAddition
            }),
            ...basicAddition,
            'dataset.chineseInstructions': this.form.chineseInstructions,
            'dataset.remark': this.form.remark,
            ...addKeyPrefix(this.itemAddition, 'item.'),
            ...this.tagAddition,
            ...this.attrAddition
          }
          addDataSet(params).then(res => {
            this.$message.success('数据集已创建')
            this.visible = false
          }).catch(e => {
            this.$message.error('创建失败')
          })
        } else {
          this.$message.error('数据集名称格式错误')
        }
      } else {
        this.$message.error('请填写数据集名称')
      }
    },
    handleCancel () {
      this.visible = false
    }
  }
}
</script>
